import React from 'react';
import PropTypes from 'prop-types';
import { TextView, pd } from '@airasia-phoenix/web';
import styled from 'styled-components';
import IconOverLap from '../OverLapIcons';
import Row from '../../Container/Row';

import {
  LineContainer,
  Dot,
  DottedLine,
  Container,
} from './TripSummary.Component';

const color = pd.sys.colour;
const font = pd.sys.typescale;

const DatePlus = styled(TextView)`
  position: absolute;
  top: 0px;
  right: -13px;
`;

const OneLineText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Summary = ({
  flightLabel,
  departTime,
  arrivalTime,
  carrierLogo,
  carrierLogo1,
  carrierLogo2,
  legs,
  days,
}) => {
  const numberOfStops =
    legs !== null && legs !== undefined ? parseInt(legs) + 1 : '';

  return (
    <>
      <Row
        justifyContent={'space-between'}
        alignItems={'center'}
        data-testid="summary"
      >
        <Row
          alignItems={'center'}
          justifyContent={'center'}
          gap="15px"
          data-testid="summary-row"
        >
          {numberOfStops && (
            <IconOverLap
              data-testid="icon-overlap"
              mt="0px"
              stop={numberOfStops}
              carrierLogo={carrierLogo}
              carrierLogo1={carrierLogo1}
              carrierLogo2={carrierLogo2}
              iconProps={{ width: '24px', height: '24px' }}
            />
          )}
          <TextView
            font={font.sub_body_text}
            color={color.container_max.color()}
            style={{
              padding: '0px',
              margin: '0px',
            }}
            data-testid="flight-label"
          >
            <OneLineText>{flightLabel}</OneLineText>
          </TextView>
          <TextView
            style={{ padding: '0px', margin: '0px' }}
            font={font.body_text}
            color={color.container_max.color()}
            data-testid="depart-time"
          >
            {departTime}
          </TextView>
        </Row>

        <Container data-testid="line-container">
          <LineContainer minWidth={'40px'} maxWidth={'40px'}>
            <Dot />
            <DottedLine />
            <Dot />
          </LineContainer>
        </Container>

        <Row alignItems={'center'} gap={'10px'}>
          <TextView
            style={{ padding: '0px', margin: '0px' }}
            font={pd.sys.typescale.body_text}
            data-testid="arrival-time"
          >
            <div style={{ position: 'relative', display: 'inline-block' }}>
              {arrivalTime}
              {Number(days) > 0 && (
                <DatePlus
                  data-testid="date-plus"
                  font={font.caption_text_small}
                  color={color.content_primary.color()}
                  variant={'span'}
                >
                  +{days}
                </DatePlus>
              )}
            </div>
          </TextView>
        </Row>
      </Row>
    </>
  );
};

Summary.propTypes = {
  flightLabel: PropTypes.string,
  departTime: PropTypes.string,
  arrivalTime: PropTypes.string,
  carrierLogo: PropTypes.string,
  carrierLogo1: PropTypes.string,
  carrierLogo2: PropTypes.string,
  legs: PropTypes.number,
  days: PropTypes.number,
};

Summary.defaultProps = {
  flightLabel: '',
  departTime: '',
  arrivalTime: '',
  carrierLogo: '',
  carrierLogo1: '',
  carrierLogo2: '',
  days: 0,
};

const OneLineTripSummary = ({
  departure,
  arrival,
  returnLabel,
  departLabel,
  carrierLogo,
  carrierLogo1,
  carrierLogo2,
  returnCarrierLogo,
  returnCarrierLogo1,
  returnCarrierLogo2,
}) => {
  const {
    departTime: departureDepartTime,
    arrivalTime: departureArrivalTime,
    legs: departureLegs,
    days: daysDeparture,
  } = departure;

  console.log({ arrival });
  const {
    departTime: returnDepartTime,
    arrivalTime: returnArrivalTime,
    legs: returnLegs,
    days: daysArrival,
  } = arrival;
  return (
    <Row gap={'30px'} data-testid="one-line-trip-summary">
      <Summary
        flightLabel={departLabel}
        departTime={departureDepartTime}
        arrivalTime={departureArrivalTime}
        carrierLogo={carrierLogo}
        carrierLogo1={carrierLogo1}
        carrierLogo2={carrierLogo2}
        legs={departureLegs}
        days={daysDeparture}
      />
      <Summary
        flightLabel={returnLabel}
        departTime={returnDepartTime}
        arrivalTime={returnArrivalTime}
        carrierLogo={returnCarrierLogo}
        carrierLogo1={returnCarrierLogo1}
        carrierLogo2={returnCarrierLogo2}
        legs={returnLegs}
        days={daysArrival}
      />
    </Row>
  );
};

OneLineTripSummary.propTypes = {
  departure: PropTypes.object,
  arrival: PropTypes.object,
  returnLabel: PropTypes.string,
  departLabel: PropTypes.string,
  carrierLogo: PropTypes.string,
  carrierLogo1: PropTypes.string,
  carrierLogo2: PropTypes.string,
  returnCarrierLogo: PropTypes.string,
  returnCarrierLogo1: PropTypes.string,
  returnCarrierLogo2: PropTypes.string,
  iconProps: PropTypes.object,
};

OneLineTripSummary.defaultProps = {
  returnLabel: 'Return',
  departLabel: 'Depart',
};

export default OneLineTripSummary;
